/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import type { VNode } from "preact";
import { useOrderDetails } from "../api/hooks.js";
import { OrderRefundScreen } from "../screens/OrderRefundScreen.js";

export function OrderRefundRoute({ orderId }: { orderId: string }): VNode {
  const { order, isLoading, error, liveError, resource, issueRefund } = useOrderDetails(orderId);
  return (
    <OrderRefundScreen
      orderId={orderId}
      order={order}
      isLoading={isLoading}
      error={error}
      orderResource={resource}
      liveUpdateError={liveError}
      onConfirmRefund={(amount, reason) => issueRefund(amount, reason).then(() => undefined)}
    />
  );
}
